import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EditorRichTextComponent } from './rich-text.component';


@NgModule({
    declarations: [
        EditorRichTextComponent,
    ],

    imports: [
        CommonModule
    ],
})
export class EditorRichTextModule {
    static components = { 'richtextElement': EditorRichTextComponent };
}
